// extracted by mini-css-extract-plugin
module.exports = {"selectItem":"UserSelector_selectItem__1ekV5"};